import { create } from 'zustand'

import { User } from '../../../shared-src/user'

type UserState = {
	user: User | null
	setUser: (user: User | null) => void
	clearUser: () => void
}

export const useUserStore = create<UserState>((set, get) => ({
	user: null,

	setUser: (user: User | null) => {
		set({ user })
	},

	clearUser: () => {
		set({ user: null })
	}
}))
